import React from 'react';
import { Activity, Zap, Cpu, HardDrive, Settings, AlertTriangle } from 'lucide-react';

const ServicesSEO = () => {
  const services = [
    {
      icon: <Activity className="h-12 w-12 text-red-600" />,
      title: 'Diagnostic automobile',
      description: 'Diagnostic électronique approfondi, lecture des défauts, analyse des paramètres et recherche de panne.'
    },
    {
      icon: <Zap className="h-12 w-12 text-red-600" />,
      title: 'Électricité automobile',
      description: 'Recherche de panne électrique, contrôle des alimentations, masses, réseaux et faisceaux.'
    },
    {
      icon: <Cpu className="h-12 w-12 text-red-600" />,
      title: 'Reprogrammation moteur',
      description: 'Optimisation de la gestion moteur avec lecture et écriture du calculateur selon le véhicule.'
    },
    {
      icon: <HardDrive className="h-12 w-12 text-red-600" />,
      title: 'Lecture & écriture ECU',
      description: 'Intervention sur différents calculateurs en OBD, Bench ou Boot selon les possibilités du calculateur.'
    },
    {
      icon: <Settings className="h-12 w-12 text-red-600" />,
      title: 'Gestion moteur',
      description: 'Analyse et résolution des problèmes liés à la gestion électronique du moteur.'
    },
    {
      icon: <AlertTriangle className="h-12 w-12 text-red-600" />,
      title: 'FAP • EGR • AdBlue • DTC',
      description: 'Diagnostic et solutions adaptées aux problèmes liés aux systèmes de dépollution et aux défauts électroniques.'
    }
  ];

  return (
    <section className="py-20 px-4 bg-gradient-to-b from-slate-950 to-slate-900" id="services-seo">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-white mb-16">
          Nos Services
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-2xl border-2 border-slate-700 hover:border-red-600 transition-all duration-300 hover:transform hover:scale-105"
            >
              <div className="mb-6 flex justify-center">
                {service.icon}
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-4 text-center">
                {service.title}
              </h3>
              
              <p className="text-gray-300 text-center leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSEO;
